export * from './lib/base-select-input.module';
export { AccredibleBaseSelectInputComponent } from '../src/lib/base-select-input.component';
